export const FilterOperator = Object.freeze({
    AND: 'and',
    OR: 'or'
});
